export const LAYER_TYPES = {
  TILE: 'TILE',
  VECTOR: 'VECTOR',
  WMS: 'WMS'
};
export const PREDEFINED_LAYERS = {
  BING: 'BING',
  OSM: 'OSM',
  XYZ: 'XYZ',
  TILE_WMS: 'TILE_WMS'
};